import { Component, OnDestroy, OnInit, Input, Output, EventEmitter, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';
import { SearchService } from '../../services/search-service.service';
import { ProductService } from '../../services/productservice';
import { Subscription, Observable } from 'rxjs';
import { AuthenticationService } from '@app/auth';
import { AuthDialogService } from '../../services/auth-dialog.service';
import { Store } from '@ngrx/store';
import { selectCurrentTheme, selectIsDarkMode } from '../../state/theme.selectors';
import { toggleTheme, setTheme } from '../../state/theme.actions';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss'],
})
export class MenuComponent implements OnInit, OnDestroy, AfterViewInit {
  @Input() isMenuOpen = false;
  @Output() closeMenuEvent = new EventEmitter<void>();

  public searchSub: Subscription | null = null;
  public searchDetails: any = {};
  public results: any[] = [];
  public refFilterResult: any[] = [];
  public searchResults: any[] = [];
  public newserachResults: string[] = [];
  public searchQuery: string = '';
  public textEnter: string = '';

  private authSubscription: Subscription | null = null;

  private langChangeSubscription: Subscription | null = null;

  isDarkMode$: Observable<boolean>;
  currentTheme$: Observable<'light' | 'dark'>;

  hoveredIsland: string | null = null;
  tooltipX: number = 0;
  tooltipY: number = 0;
  tooltipPosition: string = 'top';
  tooltipClass: string = '';

  islandPositions: { [key: string]: string } = {
    'Denis Island': 'top',
    'Bird Island': 'top',
    'North Island': 'top',
    Curieuse: 'top',
    Frégate: 'top-closer',
    'Ile Sud Ouest': 'top small',
    Poivre: 'right-lower',
    Conception: 'left',
    Therese: 'bottom',
    Mahe: 'middle-right',
    'Cerf Island': 'right',
    'Round Island': 'right',
    Silhouette: 'left',
    Cousine: 'left-top',
    Cousin: 'left-top',
    Praslin: 'left-upper',
    'Chauve Souris': 'right-top',
    'La Digue': 'bottom-closer',
    Félicité: 'right',
    'Round Island Praslin': 'right-top',
    'Grande ile': 'middle-right',
    'Ste. Anne': 'right',
    Desroches: 'top',
    Platte: 'right',
    Cosmoledo: 'left',
  };

  islandRoutes: { [key: string]: string } = {
    'Denis Island': '/listingdetails/5fc5eb839e9c3a1b67942cb6',
    'Bird Island': '/listingdetails/5fc5e597f9e417167178e022',
    'North Island': '/listingdetails/5fc4a1959e9c3a1b67942c69',
    Curieuse: '/listingdetails/5fc5ea6adc028177ff6ad847',
    Frégate: '/listingdetails/5fc5e670dc028177ff6ad835',
    Poivre: '/listingdetails/60c724887d771903bdf10785',
    Conception: '/listingdetails/5fc5d79b7d740a693d8a0573',
    Therese: '/listingdetails/60c04bedebbf77068a62355a',
    Mahe: '/listingdetails/5fc5dd8e60e8763372ea112f',
    'Cerf Island': '/listingdetails/5fc5e6eefbe6a50416e54545',
    'Round Island': '/listingdetails/5fc483ebf9e417167178dff3',
    Silhouette: '/listingdetails/5fc08a40f9e417167178dfe8',
    Cousine: '/listingdetails/5fc5e9037d740a693d8a05a1',
    Cousin: '/listingdetails/5fc5e7c1072bc33e49248093',
    Praslin: '/listingdetails/5fc5e0ba7d35d21730f781c9',
    'Chauve Souris': '/listingdetails/5fc5cf8c7d35d21730f781ac',
    'La Digue': '/listingdetails/5fc5e2a47d35d21730f781d3',
    Félicité: '/listingdetails/5fc5ec359e9c3a1b67942cbe',
    'Round Island Praslin': '/listingdetails/5fc0c71960e8763372ea1108',
    'Ste. Anne': '/listingdetails/5fbf820c072bc33e4924804d',
    Desroches: '/listingdetails/5fc5ea6b7d35d21730f781f7',
    Cosmoledo: '/listingdetails/60c71a75fd603a03bdce2f6f',
  };

  menuItems = [
    {
      id: 'plan-your-visit',
      title: 'Plan Your Visit',
      items: [
        {
          name: 'Accommodations',
          route: 'planyourvisit',
          routeParam: 'wheretostay',
          url: 'planyourvisit/wheretostay',
          cat: 'ACCOMM',
          cla: '',
        },
        {
          name: 'Getting Around',
          route: 'planyourvisit',
          routeParam: 'gettingaround',
          url: 'planyourvisit/gettingaround',
          cla: 'BICYCLE,BOAT,CAR,DOMAIRSVC,EQUIP,MINBUSCOAC,YACHT,BUSSVC,COACHSVC,FERRYSVC,TAXI',
          bannerCat: 'getting-around',
        },
        {
          name: 'Tour Operators',
          route: 'planyourvisit',
          routeParam: 'touroperators',
          url: 'planyourvisit/touroperators',
          cat: 'TOUROPERATOR',
          cla: '',
        },
        {
          name: 'Airlines',
          route: 'planyourvisit',
          routeParam: 'airlines',
          url: 'planyourvisit/airlines',
          cat: 'TRANSPORT',
          cla: 'INTAIRSVC',
        },
      ],
    },
    {
      id: 'experience',
      title: 'Experience',
      items: [
        {
          name: 'Activities',
          route: 'experience',
          routeParam: 'activities',
          url: 'experience/activities',
          cat: 'TOUR',
          bannerCat: 'activity',
          cla: '',
        },
        {
          name: 'Walks & Trails',
          route: 'experience',
          routeParam: 'walksandtrails',
          url: 'experience/walksandtrails',
          cla: 'WBTOURS,TRAIL',
          bannerCat: 'walks-trails',
        },
        {
          name: 'General Tourism Services',
          route: 'experience',
          routeParam: 'generalservices',
          url: 'experience/generalservices',
          cat: 'GENSERVICE',
          cla: '',
        },
        {
          name: 'Attractions',
          route: 'experience',
          routeParam: 'attractions',
          url: 'experience/attractions',
          cat: 'ATTRACTION',
          cla: '',
        },
        {
          name: 'Food & Drinks',
          route: 'experience',
          routeParam: 'food-drinks',
          url: 'experience/food-drinks',
          cat: 'RESTAURANT',
          cla: '',
        },
        {
          name: 'Events',
          route: 'experience',
          routeParam: 'events',
          url: 'experience/events',
          cat: 'EVENT',
          cla: '',
        },
      ],
    },
    {
      id: 'special-interests',
      title: 'Special Interests',
      items: [
        {
          name: 'Culture',
          url: 'special_interest/culture',
        },
        {
          name: 'Nature',
          url: 'special_interest/nature',
        },
        {
          name: 'Romance',
          url: 'special_interest/romance',
        },
        {
          name: 'Sustainable Seychelles',
          url: 'special_interest/sustainable_seychelles',
        },
        {
          name: 'Sailing',
          url: 'special_interest/sailing',
        },
        {
          name: 'Fishing',
          url: 'special_interest/fishing',
        },
        {
          name: 'Diving',
          url: 'special_interest/diving',
        },
      ],
    },
    {
      id: 'the-islands',
      title: 'The Islands',
      items: [
        {
          name: 'The Islands',
          route: 'experience',
          routeParam: 'theislands',
          url: 'experience/theislands',
          cat: 'DESTINFO',
          cla: 'ISLANDS',
          bannerCat: 'islands',
        },
        {
          name: 'Beaches',
          route: 'experience',
          routeParam: 'beaches',
          url: 'experience/beaches',
          cat: 'DESTINFO',
          cla: 'BEACHES',
          bannerCat: 'beaches',
        },
      ],
    },
    {
      id: 'useful-info',
      title: 'Useful Information Before Travelling',
      items: [
        {
          name: 'Brochures & Maps',
          url: 'downloads',
        },
        {
          name: 'Download Guides',
          url: 'downloads',
          fragment: 'download-guides',
        },
        {
          name: 'About Seychelles',
          route: 'aboutus',
          routeParam: 'aboutseychelles',
          url: 'aboutus/aboutseychelles',
        },
        {
          name: 'Travel Information',
          route: 'travelinfo',
          routeParam: 'travelinformation',
          url: 'travelinfo/travelinformation',
        },
      ],
    },
    {
      id: 'other',
      title: 'Other',
      items: [
        {
          name: 'Interactive Map',
          url: 'explore-seychelles',
        },
        {
          name: 'Media Hub',
          url: 'https://platform.crowdriff.com/m/visitseychelles/',
          external: true,
        },
        {
          name: 'Contact Us',
          url: 'contactus',
        },
        {
          name: 'Blogs',
          url: 'blog',
        },
      ],
    },
  ];

  currentUser: any;
  username: string | null = null;

  constructor(
    private router: Router,
    private searchService: SearchService,
    private productService: ProductService,
    private authenticationService: AuthenticationService,
    private authDialogService: AuthDialogService,
    private store: Store,
    private translateService: TranslateService
  ) {
    this.isDarkMode$ = this.store.select(selectIsDarkMode);
    this.currentTheme$ = this.store.select(selectCurrentTheme);
  }

  ngOnInit(): void {
    this.authSubscription = this.authenticationService.currentUser.subscribe((user: any) => {
      this.currentUser = user;
      if (this.currentUser) {
        this.getUsername();
      } else {
        this.username = null;
      }
    });

    this.langChangeSubscription = this.translateService.onLangChange.subscribe(() => {});
  }

  closeMenu(): void {
    this.closeMenuEvent.emit();
  }

  toggleTheme(): void {
    this.store.dispatch(toggleTheme());
  }

  search(events: { query: string }): void {
    let event = events.query.toLowerCase().trim();
    this.searchQuery = event;
    this.refFilterResult = [];
    if (this.searchSub) {
      this.searchSub.unsubscribe();
    }
    this.searchSub = this.searchService.getSearchInfo(event).subscribe((data: any) => {
      this.searchDetails = {};
      this.searchDetails = data;
      this.results = this.searchDetails.products;
      for (let i = 0; i < this.results.length; i++) {
        this.refFilterResult.push(this.results[i].productName);
      }
      this.newserachResults = [];
      this.newserachResults = [...new Set(this.refFilterResult)];
    });
  }

  searchByValue(selecedValue: string): void {
    if (selecedValue && selecedValue !== '') {
      this.closeMenu();
      this.router
        .navigateByUrl('/', { skipLocationChange: true })
        .then(() => this.router.navigate(['/app-search', selecedValue]));
    }
  }

  searchByPage(selecedValue: any): void {
    if (selecedValue && selecedValue.name !== '') {
      this.closeMenu();
      if (selecedValue.description__value == 'category') {
        this.router.navigateByUrl(selecedValue.field_rest_path);
      } else {
        this.router
          .navigateByUrl('/', { skipLocationChange: true })
          .then(() => this.router.navigate(['/app-search', selecedValue.name]));
      }
    }
  }

  goToProductDetails(val: string): void {
    let product: any = { productId: '' };
    for (let i = 0; i < this.results.length; i++) {
      if (this.results[i].productName == val) {
        product = this.results[i];
        break;
      }
    }
    this.closeMenu();
    if (product.productId == '') {
      this.router.navigate(['/app-search', val]);
    } else {
      this.router.navigate(['/listingdetails', product.productId]);
    }
  }

  getSearchDetails(selectedTerm: string): void {
    this.closeMenu();
    this.router.navigate(['/app-search', selectedTerm]);
  }

  onKeyPress(event: KeyboardEvent) {
    if (event.key === 'Enter' && this.searchQuery) {
      this.searchByValue(this.searchQuery);
    }
  }

  ngOnDestroy() {
    if (this.searchSub) {
      this.searchSub.unsubscribe();
    }
    if (this.authSubscription) {
      this.authSubscription.unsubscribe();
    }
    if (this.langChangeSubscription) {
      this.langChangeSubscription.unsubscribe();
    }
  }

  onIslandHover(event: MouseEvent, islandName: string): void {
    this.hoveredIsland = islandName;
    this.tooltipClass = this.islandPositions[islandName] || 'top';
    this.updateTooltipPosition(event, islandName);
  }

  onIslandMove(event: MouseEvent): void {
    if (this.hoveredIsland) {
      this.updateTooltipPosition(event, this.hoveredIsland);
    }
  }

  onIslandLeave(): void {
    this.hoveredIsland = null;
    this.tooltipClass = '';
  }

  updateTooltipPosition(event: MouseEvent, islandName: string): void {
    const target = event.currentTarget as SVGGElement;
    if (!target) return;

    const bbox = target.getBoundingClientRect();
    const position = this.islandPositions[islandName] || 'top';

    if (position === 'right-top') {
      this.tooltipX = bbox.right - 5; // Slight adjustment to the left
      this.tooltipY = bbox.top - 10; // Move it more to the top
    } else if (position === 'left-top') {
      this.tooltipX = bbox.left - 4; // Move 4px to the left
      this.tooltipY = bbox.top + 1; // Move 1px down from top
    } else if (position === 'left-upper') {
      this.tooltipX = bbox.left - 8; // Keep on the left side
      this.tooltipY = bbox.top + bbox.height * 0.15; // Position higher up (15% from top)
    } else if (position === 'top-closer') {
      this.tooltipX = bbox.left + bbox.width / 2;
      this.tooltipY = bbox.top - 25; // Closer to the island but not overlapping
    } else if (position.includes('top')) {
      this.tooltipX = bbox.left + bbox.width / 2;
      this.tooltipY = bbox.top - 20;
    } else if (position === 'bottom-closer') {
      this.tooltipX = bbox.left + bbox.width / 2;
      this.tooltipY = bbox.bottom + 8; // Closer to the island
    } else if (position.includes('bottom')) {
      this.tooltipX = bbox.left + bbox.width / 2;
      this.tooltipY = bbox.bottom + 20;
    } else if (position.includes('left')) {
      this.tooltipX = bbox.left - 10;
      this.tooltipY = bbox.top + bbox.height / 2;
    } else if (position === 'right-lower') {
      this.tooltipX = bbox.right + 10;
      this.tooltipY = bbox.top + bbox.height / 2 + 15;
    } else if (position.includes('right')) {
      this.tooltipX = bbox.right + 10;
      this.tooltipY = bbox.top + bbox.height / 2;
    } else if (position.includes('middle-right')) {
      this.tooltipX = bbox.left + bbox.width * 0.85; // Position near the island, towards right side
      this.tooltipY = bbox.top + bbox.height * 0.65; // Between middle and bottom
    }
  }

  onIslandClick(islandName: string): void {
    const route = this.islandRoutes[islandName];
    if (route) {
      this.closeMenu();
      window.open(route, '_blank');
    }
  }

  goToHomepage(): void {
    this.closeMenu();
    this.router.navigate(['/home']);
  }

  showLoginDialog(): void {
    this.closeMenu();
    setTimeout(() => {
      this.authDialogService.openLoginDialog();
    }, 100);
  }

  showProfileDialog(): void {
    this.closeMenu();
    this.authDialogService.openProfileDialog();
  }

  showChangePasswordDialog(): void {
    this.closeMenu();
    this.authDialogService.openChangePasswordDialog();
  }

  logout(): void {
    this.authenticationService.logout().subscribe(() => {
      this.closeMenu();
    });
  }

  goToWishlist(): void {
    this.closeMenu();
    this.router.navigate(['/wishlist']);
  }

  getUsername(): void {
    const userValue = this.authenticationService.currentUserValue;
    if (userValue && userValue.current_user) {
      this.username = userValue.current_user.name;
    } else {
      this.username = '';
    }
  }

  navigateToMenuItem(event: Event, item: any): void {
    event.preventDefault();

    if (item.external) {
      this.closeMenu();
      window.open(item.url, '_blank');
      return;
    }

    if (item.url && item.url.includes('special_interest')) {
      this.specialCategories(item);
      return;
    }

    if (item.route && item.routeParam) {
      this.categories(item);
      return;
    }

    if (item.url && item.fragment) {
      this.closeMenu();
      this.router.navigate(['/' + item.url], { fragment: item.fragment }).then(() => {
        setTimeout(() => {
          const element = document.getElementById(item.fragment);
          if (element) {
            element.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        }, 100);
      });
      return;
    }

    if (item.url) {
      this.closeMenu();
      this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => this.router.navigate(['/' + item.url]));
    }
  }

  categories(refMenu: any): void {
    if (refMenu.name == 'About Seychelles' || refMenu.name.toLowerCase() == 'about us') {
      this.router
        .navigateByUrl('/', { skipLocationChange: true })
        .then(() => this.router.navigate(['/aboutus', 'aboutseychelles']));
    } else if (refMenu.name == 'Travel Information' || refMenu.name.toLowerCase() == 'travel info') {
      this.router
        .navigateByUrl('/', { skipLocationChange: true })
        .then(() => this.router.navigate(['/travelinfo', 'travelinformation']));
    } else {
      this.router
        .navigateByUrl('/', { skipLocationChange: true })
        .then(() => this.router.navigate(['/' + refMenu.route, refMenu.routeParam]));
    }
    this.closeMenu();
  }

  specialCategories(catName: any): void {
    const catNames = catName.name.toLowerCase();
    if (catNames == 'sustainable seychelles') {
      this.router.navigate(['/special_interest/sustainable_seychelles']);
    } else {
      this.router.navigate(['/special_interest/' + catNames]);
    }
    this.closeMenu();
  }
  // this code is added for accessiblity
  ngAfterViewInit(): void {
    const input = document.querySelector('.menu-search-autocomplete input') as HTMLInputElement;

    if (input) {
      input.setAttribute('role', 'combobox');
      input.removeAttribute('aria-activedescendant');
    }
  }
}
